export const RESET_METHODS = { SMS: "sms", EMAIL: "email" };

export function isPhoneValid(phone = "") {
  return Boolean(String(phone || "").trim());
}

export function normalizeCell(value = "") {
  const v = String(value || "").trim();
  const digits = v.replace(/[^\d]/g, "");
  const m = digits.match(/^(?:1)?([2-9]\d{2}[2-9]\d{6})$/);
  return m ? m[1] : "";
}

export function isEmailValid(value = "") {
  if (!value) return "resetPasswordEmailRequired";
  const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
  return ok ? "" : "validationError";
}

export function normalizeError(val, fallback = "validationError") {
  if (val == null) return fallback;
  if (typeof val === "string") return val;
  if (typeof val === "object") {
    if (val.message) return val.message;
    if (val.id) return val.id;
    if (val.code) return val.code;
    try {
      return String(val);
    } catch {
      return fallback;
    }
  }
  return String(val);
}
